import type { AuthState } from '@wix/cli-auth';
import { createApp } from '@wix/ambassador-velo-apps-v1-app/http';
import type {
  App,
  CreateAppRequest,
} from '@wix/ambassador-velo-apps-v1-app/types';
import { AppType } from '@wix/ambassador-velo-apps-v1-app/types';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { httpRequest } from '../http-request.js';
import { catchFilesMaxSizeError } from './error-handlers/maxFileSizeErrorHandler.js';
import { loadProjectGridAppContent } from './loadProjectGridAppContent.js';

async function createAppWithParams(
  params: CreateAppRequest,
  opts: {
    authState: AuthState;
  }
): Promise<string> {
  let app: App | undefined;

  try {
    const response = await httpRequest(
      { type: 'code', authState: opts.authState },
      createApp(params)
    );
    app = response.data.app;
  } catch (err) {
    catchFilesMaxSizeError(err, params.content?.files);

    throw err;
  }

  if (!app?.id) {
    throw new CliError({
      code: CliErrorCode.InvalidCreateAppResponse(),
      info: { app },
      cause: null,
    });
  }

  return app.id;
}

export async function createMutableGridApp(
  projectFolder: string,
  opts: {
    authState: AuthState;
  }
) {
  const content = await loadProjectGridAppContent(projectFolder);

  return createAppWithParams(
    {
      app: {
        mutable: true,
        appType: AppType.VELO_ISOLATED,
      },
      content,
    },
    opts
  );
}
